/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum AccessFilter {
  All = "All",
  Yes = "Yes",
  No = "No",
}

export interface AgentRequestModel {
  displayName: string;
  description?: string | null;
  model: string;
  apiKey: string;
  modelCompany: string;
  organization: string;
}

export interface AgentResponseModel {
  /** @format uuid */
  guid: string;
  displayName: string;
  description?: string | null;
  model: string;
  apiKey: string;
  modelCompany: string;
  organization: string;
}

export interface AgentResponseModelPagedResponse {
  data: AgentResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface AnthropicModelResponseModel {
  id: string;
  displayName: string;
  /** @format date-time */
  createdAt: string;
}

export interface ClaudeFileModel {
  /** @format uuid */
  id: string;
  anthropicFileId: string;
  organization: string;
  filename: string;
  /** @format date-time */
  createdAt: string;
}

export interface ClaudeFileRequestModel {
  anthropicFileId: string;
  filename: string;
}

export interface ClaudeMemoryStoreModel {
  /** @format uuid */
  id: string;
  anthropicMemoryStoreId: string;
  organization: string;
  displayName: string;
  description?: string | null;
  /** @format date-time */
  createdAt: string;
}

export interface ClaudeMemoryStoreRequestModel {
  anthropicMemoryStoreId: string;
  displayName: string;
  description?: string | null;
}

export interface CustomProblemDetails {
  title: string;
  detail: string;
  /** @format int32 */
  status: number;
  instance: string;
  errors: string[];
}

export interface DeepIntelligenceConfigurationModel {
  /** @format uuid */
  id: string;
  displayName: string;
  description?: string | null;
  chatUserId: string;
  ownerSubjectId?: string | null;
  ownerDisplayName?: string | null;
  cronExpression: string;
  prompt: string;
  organization: string;
  /** @format uuid */
  managedAgentId: string;
  isActive: boolean;
  isPublic: boolean;
  timeZone: string;
  memoryStoreId?: string | null;
  memoryPath?: string | null;
  files?: string | null;
  selectedManagedAgentIds?: string | null;
}

export interface DeepIntelligenceConfigurationRequestModel {
  /** @format uuid */
  id?: string | null;
  displayName: string;
  description?: string | null;
  chatUserId: string;
  ownerDisplayName?: string | null;
  cronExpression: string;
  prompt: string;
  managedAgentIds: string[];
  isActive: boolean;
  isPublic: boolean;
  timeZone: string;
  memoryStoreId?: string | null;
  memoryPath?: string | null;
  files?: string | null;
}

export interface DeepIntelligenceRequestModel {
  userId: string;
  name: string;
  organization: string;
  prompt: string;
  agentId?: string | null;
  environmentId?: string | null;
  vaultId?: string | null;
  apiKey?: string | null;
}

export interface DisclosurePlaceholdersRequestModel {
  solutionName?: string | null;
  solutionPurpose?: string | null;
  solutionDataSources?: string | null;
  solutionUserGroups?: string | null;
}

export interface DisclosurePlaceholdersResponseModel {
  solutionName: string;
  solutionPurpose: string;
  solutionDataSources: string;
  solutionUserGroups: string;
}

export interface FeatureGroupAccessResponseModel {
  groupId: string;
  groupName: string;
  /** @format int32 */
  members: number;
  features: FeatureSummaryResponseModel[];
}

export interface FeatureGroupAccessResponseModelPagedResponse {
  data: FeatureGroupAccessResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface FeatureOrganizationAccessResponseModel {
  /** @format uuid */
  organizationId: string;
  name: string;
  alias: string;
  features: FeatureSummaryResponseModel[];
}

export interface FeatureSummaryModel {
  /** @format uuid */
  featureId: string;
  name: string;
  displayName: string;
}

export interface FeatureSummaryResponseModel {
  /** @format uuid */
  featureId: string;
  name: string;
  displayName: string;
}

export interface FeatureUserAccessResponseModel {
  userId: string;
  displayName: string;
  email: string;
  features: FeatureSummaryResponseModel[];
}

export interface FeatureUserAccessResponseModelPagedResponse {
  data: FeatureUserAccessResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface ManagedAgentGroupAccessResponseModel {
  /** @format uuid */
  groupId: string;
  groupName: string;
  /** @format int32 */
  members: number;
  managedAgents: ManagedAgentSummaryResponseModel[];
}

export interface ManagedAgentGroupAccessResponseModelPagedResponse {
  data: ManagedAgentGroupAccessResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface ManagedAgentOrganizationAccessResponseModel {
  /** @format uuid */
  organizationId: string;
  name: string;
  alias: string;
  managedAgents: ManagedAgentSummaryResponseModel[];
}

export interface ManagedAgentRequestModel {
  displayName: string;
  organization: string;
  agentId: string;
  environmentId: string;
  vaultId?: string | null;
  /** @format int32 */
  version?: number | null;
  isCoordinator: boolean;
  enableRls: boolean;
  userFacingDescription?: string | null;
}

export interface ManagedAgentResponseModel {
  /** @format uuid */
  guid: string;
  displayName: string;
  organization: string;
  agentId: string;
  environmentId: string;
  vaultId?: string | null;
  apiKey?: string | null;
  /** @format int32 */
  version?: number | null;
  isCoordinator: boolean;
  enableRls: boolean;
  userFacingDescription?: string | null;
}

export interface ManagedAgentResponseModelPagedResponse {
  data: ManagedAgentResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface ManagedAgentSummaryModel {
  /** @format uuid */
  guid: string;
  agentId: string;
  displayName: string;
}

export interface ManagedAgentSummaryResponseModel {
  /** @format uuid */
  guid: string;
  agentId: string;
  displayName: string;
}

export interface ManagedAgentUserAccessResponseModel {
  userId: string;
  displayName: string;
  email: string;
  managedAgents: ManagedAgentSummaryResponseModel[];
}

export interface ManagedAgentUserAccessResponseModelPagedResponse {
  data: ManagedAgentUserAccessResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface McpConfigResponseModel {
  configKey: string;
  configValue: string;
}

export interface McpConfigResponseModelPagedResponse {
  data: McpConfigResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface McpOrganizationResponseModel {
  organization: string;
}

export interface McpOrganizationResponseModelPagedResponse {
  data: McpOrganizationResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface McpRequestModel {
  name: string;
  displayName: string;
  description: string;
  internalUrl: string;
  externalUrl: string;
  transportType: string;
  organization: string;
  configType: string;
  sourceLink: string;
  isHidden: boolean;
  requiresUserToken?: boolean;
  userScopedData?: boolean;
}

export interface McpResponseModel {
  name: string;
  displayName: string;
  description: string;
  internalUrl: string;
  externalUrl: string;
  transportType: string;
  organization: string;
  configType: string;
  sourceLink: string;
  isHidden: boolean;
  requiresUserToken: boolean;
  userScopedData: boolean;
}

export interface McpResponseModelPagedResponse {
  data: McpResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface McpToolExampleEntity {
  /** @format int32 */
  id: number;
  serverName: string;
  toolName: string;
  example: string;
}

export interface OrganizationColorsRequestModel {
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
}

export interface OrganizationColorsResponseModel {
  organization: string;
  color1: string;
  color2: string;
  color3: string;
  color4: string;
  color5: string;
}

export interface OrganizationColorsResponseModelPagedResponse {
  data: OrganizationColorsResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface OrganizationDisclosureRequestModel {
  enabled: boolean;
  placeholders: DisclosurePlaceholdersRequestModel;
}

export interface OrganizationDisclosureResponseModel {
  enabled: boolean;
  placeholders: DisclosurePlaceholdersResponseModel;
  /** @format date-time */
  updatedAt?: string | null;
}

export interface OrganizationFontRequestModel {
  font: string;
  fontSize: string;
}

export interface OrganizationFontResponseModel {
  organization: string;
  font: string;
  fontSize: string;
}

export interface OrganizationFontResponseModelPagedResponse {
  data: OrganizationFontResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface OrganizationWorkspaceApiKeyResponseModel {
  apiKey?: string | null;
}

export interface OrganizationWorkspaceForManagedAgentsRequestModel {
  apiKey: string;
}

export interface OrganizationWorkspaceStatusResponseModel {
  hasApiKey: boolean;
}

export interface SuggestedPromptResponseModel {
  /** @format uuid */
  id: string;
  prompt: string;
  label: string;
}

export interface SuggestedPromptResponseModelPagedResponse {
  data: SuggestedPromptResponseModel[];
  /** @format int32 */
  rows: number;
}

export interface UpdateFeatureGroupAccessRequestModel {
  /** @format uuid */
  groupId: string;
  featureIds: string[];
}

export interface UpdateFeatureOrganizationAccessRequestModel {
  alias: string;
  featureIds: string[];
}

export interface UpdateFeatureUserAccessRequestModel {
  userId: string;
  featureIds: string[];
}

export interface UpdateManagedAgentGroupAccessRequestModel {
  /** @format uuid */
  groupId: string;
  managedAgentGuids: string[];
}

export interface UpdateManagedAgentOrganizationAccessRequestModel {
  alias: string;
  managedAgentGuids: string[];
}

export interface UpdateManagedAgentUserAccessRequestModel {
  userId: string;
  managedAgentGuids: string[];
}

export interface UpsertToolExampleRequest {
  serverName: string;
  toolName: string;
  example: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  JsonApi = "application/vnd.api+json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = import.meta.env.VITE_APP_API_BASE_URL || "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.JsonApi]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) => {
      if (input instanceof FormData) {
        return input;
      }

      return Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData());
    },
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title api
 * @version v1
 */
export class MgmtApi<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Access
     * @name V1AccessFeaturesList
     * @request GET:/api/v1/Access/features
     * @secure
     */
    v1AccessFeaturesList: (params: RequestParams = {}) =>
      this.request<FeatureSummaryModel[], CustomProblemDetails>({
        path: `/api/v1/Access/features`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessFeaturesMeList
     * @request GET:/api/v1/Access/features/me
     * @secure
     */
    v1AccessFeaturesMeList: (params: RequestParams = {}) =>
      this.request<FeatureSummaryResponseModel[], CustomProblemDetails>({
        path: `/api/v1/Access/features/me`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessFeaturesUsersList
     * @request GET:/api/v1/Access/features/users
     * @secure
     */
    v1AccessFeaturesUsersList: (
      query: {
        /** @format int32 */
        Page: number;
        /** @format int32 */
        Size: number;
        Filter?: string;
        AccessFilter: AccessFilter;
        SortBy?: string;
        IsDescending: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FeatureUserAccessResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/Access/features/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessFeaturesUsersUpdate
     * @request PUT:/api/v1/Access/features/users
     * @secure
     */
    v1AccessFeaturesUsersUpdate: (
      data: UpdateFeatureUserAccessRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Access/features/users`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessFeaturesGroupsList
     * @request GET:/api/v1/Access/features/groups
     * @secure
     */
    v1AccessFeaturesGroupsList: (
      query: {
        /** @format int32 */
        Page: number;
        /** @format int32 */
        Size: number;
        Filter?: string;
        AccessFilter: AccessFilter;
        SortBy?: string;
        IsDescending: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        FeatureGroupAccessResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/Access/features/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessFeaturesGroupsUpdate
     * @request PUT:/api/v1/Access/features/groups
     * @secure
     */
    v1AccessFeaturesGroupsUpdate: (
      data: UpdateFeatureGroupAccessRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Access/features/groups`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessFeaturesOrganizationsList
     * @request GET:/api/v1/Access/features/organizations
     * @secure
     */
    v1AccessFeaturesOrganizationsList: (params: RequestParams = {}) =>
      this.request<
        FeatureOrganizationAccessResponseModel,
        CustomProblemDetails
      >({
        path: `/api/v1/Access/features/organizations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessFeaturesOrganizationsUpdate
     * @request PUT:/api/v1/Access/features/organizations
     * @secure
     */
    v1AccessFeaturesOrganizationsUpdate: (
      data: UpdateFeatureOrganizationAccessRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Access/features/organizations`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessManagedagentsList
     * @request GET:/api/v1/Access/managedagents
     * @secure
     */
    v1AccessManagedagentsList: (params: RequestParams = {}) =>
      this.request<ManagedAgentSummaryModel[], CustomProblemDetails>({
        path: `/api/v1/Access/managedagents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessManagedagentsUsersList
     * @request GET:/api/v1/Access/managedagents/users
     * @secure
     */
    v1AccessManagedagentsUsersList: (
      query: {
        /** @format int32 */
        Page: number;
        /** @format int32 */
        Size: number;
        Filter?: string;
        AccessFilter: AccessFilter;
        SortBy?: string;
        IsDescending: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedAgentUserAccessResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/Access/managedagents/users`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessManagedagentsUsersUpdate
     * @request PUT:/api/v1/Access/managedagents/users
     * @secure
     */
    v1AccessManagedagentsUsersUpdate: (
      data: UpdateManagedAgentUserAccessRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Access/managedagents/users`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessManagedagentsGroupsList
     * @request GET:/api/v1/Access/managedagents/groups
     * @secure
     */
    v1AccessManagedagentsGroupsList: (
      query: {
        /** @format int32 */
        Page: number;
        /** @format int32 */
        Size: number;
        Filter?: string;
        AccessFilter: AccessFilter;
        SortBy?: string;
        IsDescending: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<
        ManagedAgentGroupAccessResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/Access/managedagents/groups`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessManagedagentsGroupsUpdate
     * @request PUT:/api/v1/Access/managedagents/groups
     * @secure
     */
    v1AccessManagedagentsGroupsUpdate: (
      data: UpdateManagedAgentGroupAccessRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Access/managedagents/groups`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessManagedagentsOrganizationsList
     * @request GET:/api/v1/Access/managedagents/organizations
     * @secure
     */
    v1AccessManagedagentsOrganizationsList: (params: RequestParams = {}) =>
      this.request<
        ManagedAgentOrganizationAccessResponseModel,
        CustomProblemDetails
      >({
        path: `/api/v1/Access/managedagents/organizations`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Access
     * @name V1AccessManagedagentsOrganizationsUpdate
     * @request PUT:/api/v1/Access/managedagents/organizations
     * @secure
     */
    v1AccessManagedagentsOrganizationsUpdate: (
      data: UpdateManagedAgentOrganizationAccessRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Access/managedagents/organizations`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agents
     * @name V1AgentsList
     * @request GET:/api/v1/Agents
     * @secure
     */
    v1AgentsList: (params: RequestParams = {}) =>
      this.request<AgentResponseModelPagedResponse, CustomProblemDetails>({
        path: `/api/v1/Agents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agents
     * @name V1AgentsCreate
     * @request POST:/api/v1/Agents
     * @secure
     */
    v1AgentsCreate: (data: AgentRequestModel, params: RequestParams = {}) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Agents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Agents
     * @name V1AgentsUpdate
     * @request PUT:/api/v1/Agents/{guid}
     * @secure
     */
    v1AgentsUpdate: (
      guid: string,
      data: AgentRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Agents/${guid}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags AnthropicModels
     * @name V1AnthropicModelsList
     * @request GET:/api/v1/AnthropicModels
     * @secure
     */
    v1AnthropicModelsList: (params: RequestParams = {}) =>
      this.request<AnthropicModelResponseModel[], CustomProblemDetails>({
        path: `/api/v1/AnthropicModels`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClaudeFiles
     * @name V1ClaudeFilesList
     * @request GET:/api/v1/ClaudeFiles
     * @secure
     */
    v1ClaudeFilesList: (params: RequestParams = {}) =>
      this.request<ClaudeFileModel[], any>({
        path: `/api/v1/ClaudeFiles`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClaudeFiles
     * @name V1ClaudeFilesCreate
     * @request POST:/api/v1/ClaudeFiles
     * @secure
     */
    v1ClaudeFilesCreate: (
      data: ClaudeFileRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<ClaudeFileModel, CustomProblemDetails>({
        path: `/api/v1/ClaudeFiles`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClaudeFiles
     * @name V1ClaudeFilesDelete
     * @request DELETE:/api/v1/ClaudeFiles/{id}
     * @secure
     */
    v1ClaudeFilesDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/ClaudeFiles/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClaudeMemoryStores
     * @name V1ClaudeMemoryStoresList
     * @request GET:/api/v1/ClaudeMemoryStores
     * @secure
     */
    v1ClaudeMemoryStoresList: (params: RequestParams = {}) =>
      this.request<ClaudeMemoryStoreModel[], any>({
        path: `/api/v1/ClaudeMemoryStores`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClaudeMemoryStores
     * @name V1ClaudeMemoryStoresCreate
     * @request POST:/api/v1/ClaudeMemoryStores
     * @secure
     */
    v1ClaudeMemoryStoresCreate: (
      data: ClaudeMemoryStoreRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<ClaudeMemoryStoreModel, CustomProblemDetails>({
        path: `/api/v1/ClaudeMemoryStores`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ClaudeMemoryStores
     * @name V1ClaudeMemoryStoresDelete
     * @request DELETE:/api/v1/ClaudeMemoryStores/{id}
     * @secure
     */
    v1ClaudeMemoryStoresDelete: (id: string, params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/ClaudeMemoryStores/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeepIntelligence
     * @name V1DeepIntelligencePublishCreate
     * @request POST:/api/v1/DeepIntelligence/publish
     * @secure
     */
    v1DeepIntelligencePublishCreate: (
      data: DeepIntelligenceRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/DeepIntelligence/publish`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeepIntelligenceConfiguration
     * @name V1DeepIntelligenceConfigurationList
     * @request GET:/api/v1/DeepIntelligenceConfiguration
     * @secure
     */
    v1DeepIntelligenceConfigurationList: (params: RequestParams = {}) =>
      this.request<DeepIntelligenceConfigurationModel[], any>({
        path: `/api/v1/DeepIntelligenceConfiguration`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeepIntelligenceConfiguration
     * @name V1DeepIntelligenceConfigurationCreate
     * @request POST:/api/v1/DeepIntelligenceConfiguration
     * @secure
     */
    v1DeepIntelligenceConfigurationCreate: (
      data: DeepIntelligenceConfigurationRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<DeepIntelligenceConfigurationModel, CustomProblemDetails>({
        path: `/api/v1/DeepIntelligenceConfiguration`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeepIntelligenceConfiguration
     * @name V1DeepIntelligenceConfigurationDelete
     * @request DELETE:/api/v1/DeepIntelligenceConfiguration/{id}
     * @secure
     */
    v1DeepIntelligenceConfigurationDelete: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/DeepIntelligenceConfiguration/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags DeepIntelligenceConfiguration
     * @name V1DeepIntelligenceConfigurationTestCreate
     * @request POST:/api/v1/DeepIntelligenceConfiguration/{id}/test
     * @secure
     */
    v1DeepIntelligenceConfigurationTestCreate: (
      id: string,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/DeepIntelligenceConfiguration/${id}/test`,
        method: "POST",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Healths
     * @name V1HealthsLiveList
     * @request GET:/api/v1/Healths/live
     * @secure
     */
    v1HealthsLiveList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Healths/live`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Healths
     * @name V1HealthsReadyList
     * @request GET:/api/v1/Healths/ready
     * @secure
     */
    v1HealthsReadyList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Healths/ready`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Healths
     * @name V1HealthsStartupList
     * @request GET:/api/v1/Healths/startup
     * @secure
     */
    v1HealthsStartupList: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/v1/Healths/startup`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ManagedAgents
     * @name V1ManagedAgentsList
     * @request GET:/api/v1/ManagedAgents
     * @secure
     */
    v1ManagedAgentsList: (params: RequestParams = {}) =>
      this.request<
        ManagedAgentResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/ManagedAgents`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ManagedAgents
     * @name V1ManagedAgentsCreate
     * @request POST:/api/v1/ManagedAgents
     * @secure
     */
    v1ManagedAgentsCreate: (
      data: ManagedAgentRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/ManagedAgents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ManagedAgents
     * @name V1ManagedAgentsAccessibleList
     * @request GET:/api/v1/ManagedAgents/accessible
     * @secure
     */
    v1ManagedAgentsAccessibleList: (params: RequestParams = {}) =>
      this.request<
        ManagedAgentResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/ManagedAgents/accessible`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags ManagedAgents
     * @name V1ManagedAgentsUpdate
     * @request PUT:/api/v1/ManagedAgents/{guid}
     * @secure
     */
    v1ManagedAgentsUpdate: (
      guid: string,
      data: ManagedAgentRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/ManagedAgents/${guid}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags ManagedAgents
     * @name V1ManagedAgentsDelete
     * @request DELETE:/api/v1/ManagedAgents/{guid}
     * @secure
     */
    v1ManagedAgentsDelete: (guid: string, params: RequestParams = {}) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/ManagedAgents/${guid}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mcps
     * @name V1McpsList
     * @request GET:/api/v1/Mcps
     * @secure
     */
    v1McpsList: (params: RequestParams = {}) =>
      this.request<McpResponseModelPagedResponse, CustomProblemDetails>({
        path: `/api/v1/Mcps`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mcps
     * @name V1McpsCreate
     * @request POST:/api/v1/Mcps
     * @secure
     */
    v1McpsCreate: (data: McpRequestModel, params: RequestParams = {}) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Mcps`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mcps
     * @name V1McpsDetail
     * @request GET:/api/v1/Mcps/{name}
     * @secure
     */
    v1McpsDetail: (name: string, params: RequestParams = {}) =>
      this.request<McpConfigResponseModelPagedResponse, CustomProblemDetails>({
        path: `/api/v1/Mcps/${name}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mcps
     * @name V1McpsOrganizationList
     * @request GET:/api/v1/Mcps/{McpName}/organization
     * @secure
     */
    v1McpsOrganizationList: (mcpName: string, params: RequestParams = {}) =>
      this.request<
        McpOrganizationResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/Mcps/${mcpName}/organization`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mcps
     * @name V1McpsToolsExampleList
     * @request GET:/api/v1/Mcps/tools/example
     * @secure
     */
    v1McpsToolsExampleList: (
      query?: {
        server?: string;
        toolName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<McpToolExampleEntity, any>({
        path: `/api/v1/Mcps/tools/example`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mcps
     * @name V1McpsToolsExampleCreate
     * @request POST:/api/v1/Mcps/tools/example
     * @secure
     */
    v1McpsToolsExampleCreate: (
      data: UpsertToolExampleRequest,
      params: RequestParams = {},
    ) =>
      this.request<McpToolExampleEntity, any>({
        path: `/api/v1/Mcps/tools/example`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mcps
     * @name V1McpsToolsExampleUpdate
     * @request PUT:/api/v1/Mcps/tools/example
     * @secure
     */
    v1McpsToolsExampleUpdate: (
      data: UpsertToolExampleRequest,
      params: RequestParams = {},
    ) =>
      this.request<McpToolExampleEntity, any>({
        path: `/api/v1/Mcps/tools/example`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Mcps
     * @name V1McpsToolsExampleDelete
     * @request DELETE:/api/v1/Mcps/tools/example
     * @secure
     */
    v1McpsToolsExampleDelete: (
      query?: {
        server?: string;
        toolName?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<void, any>({
        path: `/api/v1/Mcps/tools/example`,
        method: "DELETE",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsManagedAgentWorkspaceStatusList
     * @request GET:/api/v1/Organizations/managed-agent-workspace-status
     * @secure
     */
    v1OrganizationsManagedAgentWorkspaceStatusList: (
      params: RequestParams = {},
    ) =>
      this.request<OrganizationWorkspaceStatusResponseModel, any>({
        path: `/api/v1/Organizations/managed-agent-workspace-status`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsManagedAgentWorkspaceStatusCreate
     * @request POST:/api/v1/Organizations/managed-agent-workspace-status
     * @secure
     */
    v1OrganizationsManagedAgentWorkspaceStatusCreate: (
      data: OrganizationWorkspaceForManagedAgentsRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Organizations/managed-agent-workspace-status`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsManagedAgentWorkspaceApiKeyList
     * @request GET:/api/v1/Organizations/managed-agent-workspace-api-key
     * @secure
     */
    v1OrganizationsManagedAgentWorkspaceApiKeyList: (
      params: RequestParams = {},
    ) =>
      this.request<OrganizationWorkspaceApiKeyResponseModel, any>({
        path: `/api/v1/Organizations/managed-agent-workspace-api-key`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsColorsList
     * @request GET:/api/v1/Organizations/colors
     * @secure
     */
    v1OrganizationsColorsList: (params: RequestParams = {}) =>
      this.request<
        OrganizationColorsResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/Organizations/colors`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsColorsCreate
     * @request POST:/api/v1/Organizations/colors
     * @secure
     */
    v1OrganizationsColorsCreate: (
      data: OrganizationColorsRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Organizations/colors`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsColorsDetail
     * @request GET:/api/v1/Organizations/colors/{organizationName}
     * @secure
     */
    v1OrganizationsColorsDetail: (
      organizationName: string,
      params: RequestParams = {},
    ) =>
      this.request<
        OrganizationColorsResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/Organizations/colors/${organizationName}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsFontsList
     * @request GET:/api/v1/Organizations/fonts
     * @secure
     */
    v1OrganizationsFontsList: (params: RequestParams = {}) =>
      this.request<
        OrganizationFontResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/Organizations/fonts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsFontsCreate
     * @request POST:/api/v1/Organizations/fonts
     * @secure
     */
    v1OrganizationsFontsCreate: (
      data: OrganizationFontRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Organizations/fonts`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsDisclosureList
     * @request GET:/api/v1/Organizations/disclosure
     * @secure
     */
    v1OrganizationsDisclosureList: (params: RequestParams = {}) =>
      this.request<OrganizationDisclosureResponseModel, CustomProblemDetails>({
        path: `/api/v1/Organizations/disclosure`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Organizations
     * @name V1OrganizationsDisclosureCreate
     * @request POST:/api/v1/Organizations/disclosure
     * @secure
     */
    v1OrganizationsDisclosureCreate: (
      data: OrganizationDisclosureRequestModel,
      params: RequestParams = {},
    ) =>
      this.request<void, CustomProblemDetails>({
        path: `/api/v1/Organizations/disclosure`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags SuggestedPrompts
     * @name V1SuggestedPromptsList
     * @request GET:/api/v1/SuggestedPrompts
     * @secure
     */
    v1SuggestedPromptsList: (params: RequestParams = {}) =>
      this.request<
        SuggestedPromptResponseModelPagedResponse,
        CustomProblemDetails
      >({
        path: `/api/v1/SuggestedPrompts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}
